import React from 'react'
import styled from 'styled-components'
import {
    VerticalTimeline,
    VerticalTimelineElement
  } from "react-vertical-timeline-component";
  
import "react-vertical-timeline-component/style.min.css";
import { timelineData } from './TimelineData';
import {BsFillBriefcaseFill} from 'react-icons/bs'


const Experience = () => {
    let tlIconStyle = {backgroundColor: '#FFD05880'}
    return (
    <StyledExperience>
        <div className="experience-container">
            <div className="experience-header">
                <h1>Experience</h1>
            </div>


            <div className="timeline-container">
                <VerticalTimeline
                 layout='1-column-left'
                >
                    {
                        timelineData.map((item) => {{
                            let isWorkIcon  =  <BsFillBriefcaseFill/>
                            
                            return(
                                <VerticalTimelineElement
                                key={item.key}
                                date={item.date}
                               
                                dateClassName="date"
                                iconStyle={isWorkIcon ? tlIconStyle : tlIconStyle}
                                icon={isWorkIcon ? <BsFillBriefcaseFill/> : <BsFillBriefcaseFill />}
                               >
                                    <h3 className="vertical-timeline-element-title">{item.title}</h3>
                                    <h4 className="vertical-timeline-element-subtitle">{item.company}</h4>
                                    <p>{item.description}</p>

                                </VerticalTimelineElement>
                            )
                        }})
                    }
                </VerticalTimeline>
            </div>

        </div>
    </StyledExperience>
  )
}

export default Experience

const StyledExperience = styled.div`
    
    position: relative;
    box-sizing: border-box;
   
    @media( max-width: 730px) {
        margin-top: 10rem;
    }
    .experience-container{
       
        .experience-header{
            display: flex;
            justify-content: flex-start;
            padding: 0rem 7.625rem 0rem 7.5rem;
            @media (max-width: 768px) {
                padding: 0rem 1.875rem 0rem 1.25rem;
            }
            @media( max-width: 768px){
                    font-size: 3.125rem;
                    line-height: 4.375rem;
                }
            h1{
                font-family: 'Space Grotesk', sans-serif;
                font-weight: 500;
                font-size: 7.5rem;
                line-height: 9.5625rem;
                text-transform: uppercase;
                color: #333333;

                @media( max-width: 768px){
                    font-size: 3.125rem;
                    line-height: 4.375rem;
                }
            }
        }
    }

    .timeline-container{
        padding-left: 7.625rem;
        @media (max-width: 768px) {
            padding-left: 1.875rem;
        }
    }

    .vertical-timeline{
        width: 40%;
        margin: 0;
        @media (max-width: 768px) {
            width: 90%;
        }
    }
    .vertical-timeline-element-title{
        font-family: 'Space Grotesk', sans-serif;
        font-weight: 500;
        font-size: 2.5rem;
        line-height: 3.1875rem;

        @media( max-width: 768px){
            font-size: 1.5rem;
            line-height: 1.875rem;
        }
    }
    .vertical-timeline-element-subtitle{
        font-family: 'Space Grotesk', sans-serif;
        font-weight: 400;
        font-size: 1.5625rem;
        line-height: 1.9375rem;
        color: #4F4F4F;
        text-transform: uppercase;

        @media (max-width: 768px) {
            font-size: 1rem;
        }
    }
    .vertical-timeline-element-content{
        box-shadow: 0 0 0 0;
    }
`